module.exports = __webpack_public_path__ + "static/media/stop-circle.f30cc3b5.svg";